export default function toFormData(formValues: any) {
  const formData = new FormData();
  Object.entries(formValues).forEach(([key, value]) => {
    formData.append(key, value as string | Blob);
  });
  return formData;
}
